export function oneOrBothTrue(
  promise1: Promise<boolean>,
  promise2: Promise<boolean>,
): Promise<boolean> {
  return Promise.all([promise1, promise2]).then((values) => {
    return values[0] || values[1];
  });
}
